/**
 * Vue 应用入口
 * 
 * 初始化:
 * - Vue 应用实例
 * - Pinia 状态管理
 * - Vue Router 路由
 * - i18n 国际化
 * - Element Plus UI 框架
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/main.scss'

/**
 * 创建 Vue 应用实例
 */
const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ElementPlus)

router.isReady().then(() => {
  app.mount('#app')
})
